<template>
  <div v-if="1==2">
    <div @click.prevent="irParaOTopo" class="text-xs-center grey--text text--darken-1 my-4">
      <v-icon class="text-xs-center grey--text text--darken-1 cursor_pointer">arrow_upwards</v-icon>
      <br>
      <span class="cursor_pointer">Ir para o topo</span>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        scrollHeight: document.body.scrollHeight,
        windowHeight: document.body.clientHeight
      }
    },
    methods: {
      irParaOTopo: function () {
        let cosParameter = window.scrollY / 2
        let scrollCount = 0
        let oldTimestamp = performance.now()

        function step (newTimestamp) {
          scrollCount += Math.PI / (1000 / (newTimestamp - oldTimestamp))
          if (scrollCount >= Math.PI) window.scrollTo(0, 0)
          if (window.scrollY === 0) return
          window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)))
          oldTimestamp = newTimestamp
          window.requestAnimationFrame(step)
        }
        window.requestAnimationFrame(step)
      }
    }
  }
</script>

<style scoped>
  i { font-size: 24px; width: 24px; display: inline-block; margin-bottom: 5px; }
</style>



// WEBPACK FOOTER //
// IrParaOTopo.vue?1ded118f